import styled, { css } from 'styled-components/macro';
import { Link } from '@yme/components/Link';
import { colorBlackTransparent100, colorBrandYamahaRed, colorCoreBlack1000, colorCoreWhite1000, } from '@yme/tokens/colors';
import { ADAPTIVE } from '@yme/tokens/screen';
import { INDENT } from '@yme/tokens/sizes';
import { Z_INDEX } from '@yme/tokens/zindex';
import { getTextStyles } from '@yme/utils/styles';
const ProfileMenuAfter = css `
  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    margin: 0 auto;
    z-index: -1;
    border-radius: 20px;
    width: 40px;
    height: 40px;
    background-color: ${colorBlackTransparent100};
    display: none;
  }

  &:hover {
    &::after {
      display: block;
    }
  }
`;
export const CartMenuItemWrapper = styled.div `
  position: relative;
  padding: 8px;
  align-items: center;
  align-self: center;
`;
export const ProfileMenuStyled = styled.nav `
  display: flex;
  align-items: center;

  & > span,
  & > a {
    ${ProfileMenuAfter};

    position: relative;
    padding: ${INDENT.xxxs};

    cursor: pointer;

    align-items: center;

    /* TODO: (D.K.) Need investigate this approach */
    dominant-baseline: middle;

    align-self: center;

    z-index: ${Z_INDEX.level1};
  }

  ${({ isRightToLeft }) => isRightToLeft
    ? css `
          & > a,
          & > span:not(:last-child) {
            margin-left: ${INDENT.xxxs};

            ${ADAPTIVE.minWidth.desktopLg} {
              margin-left: 0;
            }
          }
        `
    : css `
          & > a,
          & > span:not(:last-child) {
            margin-right: ${INDENT.xxxs};

            ${ADAPTIVE.minWidth.desktopLg} {
              margin-right: 0;
            }
          }
        `};
`;
export const SearchMenuItem = styled.a `
  position: relative;
  ${ProfileMenuAfter};
`;
export const CartMenuItem = styled(Link) `
  cursor: pointer;
  ${ProfileMenuAfter};
`;
export const DealerLocatorMenuItem = styled(Link) `
  position: relative;
  ${ProfileMenuAfter};
`;
export const WishlistMenuItem = styled(Link) `
  position: relative;
  ${ProfileMenuAfter};
  svg g path {
    fill: ${colorCoreBlack1000};
    stroke: ${colorCoreBlack1000};
    transition: all 0.2s ease-in;
  }
`;
export const Badge = styled.span `
  position: absolute;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  top: 0;
  right: ${({ right }) => (right ? `${right}px` : 0)};
  min-width: ${INDENT.xs};
  height: ${INDENT.xs};
  padding-left: 2px;
  padding-right: 2px;
  border: 2px solid ${colorCoreWhite1000};
  border-radius: 20px;
  background-color: ${colorBrandYamahaRed};
  ${getTextStyles('Ubuntu', 500, 12, 16)}
  color: ${colorCoreWhite1000};
`;
